<app-product
  *ngFor="let product of products | async"
  [product]="product"
  [mode]="'mini'"
></app-product>
